<template>
  <div class="view-product-coproducers">
    <bp-header
      class="mb-7"
      title="Coproduções"
      subtitle="Compartilhe o produto com seus coprodutores."
    />

    <bp-table-header :total="pagination.count" @refresh="refresh">
      <template #buttons>
        <bp-button
          size="md"
          icon="fa-light fa-plus"
          label="Cadastrar coprodutor"
          @click="addCoproducer"
        />
      </template>
    </bp-table-header>

    <bp-data-table
      class="my-7"
      :loading="loading"
      :columns="columns"
      :data="coproducers"
    />

    <bp-paginator
      v-if="!loading"
      v-model="page"
      :pagination="pagination"
      @change-page="dispatch"
    />

    <responsive-modal v-model="modal" size="lg" title="Cadastrar coprodutor">
      <coproducer-modal
        :productId="$route.params.id"
        @refresh="refresh"
        @close="modal = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import CoproducerModal from "@/components/product/coproducer/CoproducerModal.vue";

import { formatDate, formatPercentage } from "@/functions/formatting";
import { mapState } from "vuex";

export default {
  components: { CoproducerModal },
  data() {
    return {
      page: 1,
      columns: [
        {
          name: "E-mail",
          field: "co_producer",
          transform: v => v.email
        },
        {
          name: "Comissão",
          field: "tax",
          transform: formatPercentage,
          size: "0.7fr"
        },
        {
          name: "Validade do contrato",
          field: "contract_time",
          transform: formatDate,
          size: "0.7fr"
        },
        {
          name: "Status",
          field: "status",
          transform: this.formatStatus,
          class: this.formatStatusBadge,
          size: "0.7fr"
        },
        {
          name: "",
          type: "menu",
          disabled: ({ status }) => status !== "active",
          options: v => [
            {
              label: "Desativar",
              color: "negative",
              icon: "fa-light fa-power-off",
              click: this.deactivateCoproducer,
              dialog: {
                text: `Deseja mesmo desativar a coprodução com ${v.co_producer.email}?`,
                variant: "negative",
                icon: "fa fa-hexagon-exclamation",
                secondaryAction: this.deactivateCoproducer,
                buttonText: "Cancelar",
                secondaryButtonText: "Confirmar"
              }
            }
          ]
        }
      ],
      modal: false,
      loading: false
    };
  },
  computed: {
    ...mapState("user", ["coproducers", "pagination"])
  },
  methods: {
    refresh() {
      this.page = 1;
      this.dispatch();
    },
    dispatch(offset = 0) {
      this.loading = true;
      this.$store
        .dispatch("user/getCoProducerByProduct", {
          id: this.$route.params.id,
          offset
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatStatus(status) {
      const statusMap = {
        active: "Ativo",
        cancelled: "Inativo",
        rejected: "Rejeitado",
        waiting_validation: "Aguardando Aprovação",
        pendent: "Pendente"
      };

      return statusMap[status];
    },
    formatStatusBadge(status) {
      const statusMap = {
        active: "active-badge",
        cancelled: "inactive-badge",
        rejected: "inactive-badge",
        waiting_validation: "draft-badge",
        pendent: "draft-badge"
      };

      return statusMap[status];
    },

    addCoproducer() {
      this.modal = true;
    },
    deactivateCoproducer(coproducer) {
      this.$store
        .dispatch("user/putCoProducerProduct", {
          id: coproducer.id,
          status: "cancelled"
        })
        .then(() => {
          this.$message.success("Coprodução desativada");
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao desativar coprodução"));
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
